module.exports = __webpack_public_path__ + "img/Mohsin Ali.jpg";